/**
 * @fileoverview GET handler for the "/engagement/feature_flag_rollouts_data/:feature_flag_bson_id/:app_group_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementFeatureFlagRolloutsDataFeatureFlagBsonIdAppGroupId } from "./constants";
import type { GetEngagementFeatureFlagRolloutDataById } from "./types";

export const getEngagementFeatureFlagRolloutsDataFeatureFlagBsonIdAppGroupId = reactQueryFetcherAdapter(
  engagementFeatureFlagRolloutsDataFeatureFlagBsonIdAppGroupId,
  (
    signal: AbortSignal,
    featureFlagBsonId: string,
    appGroupId: string
  ): Promise<GetEngagementFeatureFlagRolloutDataById> => {
    return fetch(
      `/engagement/feature_flag_rollouts_data/${featureFlagBsonId}/${appGroupId}`,
      "GET",
      {},
      { signal }
    );
  }
);
